import {
  useBulkUpdateVendorsMutation,
  useToggleBaseUserStatusMutation,
} from "generated/graphql"
import React from "react"
import { ErrorToast, SuccessToast } from "utils/AppToaster"

export function useToggleUserStatusMutation(id: number) {
  return useToggleBaseUserStatusMutation({
    variables: {
      userId: id,
    },
    onCompleted({ delBaseUser }) {
      const usr = delBaseUser?.user

      SuccessToast(
        <span>
          Status of user {usr?.fullName} changed to
          <strong className="ml-2">{usr?.status}</strong>
        </span>
      )
    },
    onError() {
      ErrorToast(`Unable to change the status`)
    },
  })
}

export function useBulkUserStatusUpdate() {
  return useBulkUpdateVendorsMutation({
    onCompleted({ bulkUpdateUsers }) {
      const users = bulkUpdateUsers?.users

      SuccessToast(
        <span>
          Status of {users?.length} users changed to
          <strong className="ml-2">{users?.[0]?.status}</strong>
        </span>
      )
    },
    onError() {
      ErrorToast(`Unable to change the status`)
    },
  })
}
